<div>
    <ul role="list" class="grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">

        <!-- Active Briefs -->
        <li routerLink="/briefs" class="col-span-1 flex rounded-md card-animate hover:cursor-pointer" style="animation-delay: 0s;">
            <div
                class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-gradient-to-br from-[#8b5cf6] to-[#ec4899] text-sm font-medium text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-8">
                    <path
                        d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" />
                    <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                    <path d="m9 15 2 2 4-4" />
                </svg>
            </div>
            <div
                class="flex flex-1 items-center justify-between truncate rounded-r-md border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-gray-800/50">
                <div class="flex-1 truncate px-4 py-2 text-sm">
                    <p class="text-secondary">Active Briefs</p>
                    <div class="flex flex-row items-baseline gap-x-2">
                        <p class="text-2xl font-semibold text-primary">{{ topLineStats()?.applicationsHiredOrStarted }}
                        </p>
                        @if (topLineStats() && topLineStats()!.allActiveBriefsChange &&
                        topLineStats()!.allActiveBriefsChange > 0) {
                        <p class="flex items-baseline text-sm font-semibold text-green-600 dark:text-green-400">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5 shrink-0 self-center text-green-500 dark:text-green-400">
                                <path
                                    d="M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            <span class="sr-only"> Increased by </span>
                            {{ topLineStats()?.allActiveBriefsChange }}
                        </p>
                        } @else if (topLineStats() && topLineStats()!.allActiveBriefsChange &&
                        topLineStats()!.allActiveBriefsChange < 0) { <p
                            class="flex items-baseline text-sm font-semibold text-red-600 dark:text-red-400">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                class="size-5 shrink-0 self-center text-red-500 dark:text-red-400">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                            </svg>

                            <span class="sr-only"> Decreased by </span>
                            {{ topLineStats()?.allActiveBriefsChange }}
                            </p>
                            }
                    </div>

                </div>


            </div>
        </li>
        <!-- Active Briefs - END -->

        <!-- Waiting Applications -->
        <li class="col-span-1 flex rounded-md card-animate" style="animation-delay: 0s;">
            <div
                class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-gradient-to-br from-[rgb(6,182,212)] to-[rgb(124,58,237)] text-sm font-medium text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-8">
                    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                    <path
                        d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
                </svg>
            </div>
            <div
                class="flex flex-1 items-center justify-between truncate rounded-r-md border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-gray-800/50">
                <div class="flex-1 truncate px-4 py-2 text-sm">
                    <p class="text-secondary">Waiting Applications</p>
                    <div class="flex flex-row items-baseline gap-x-2">
                        <p class="text-2xl font-semibold text-primary">{{ topLineStats()?.applicationsApplied }}</p>
                        @if (topLineStats() && topLineStats()!.applicationsAppliedChange &&
                        topLineStats()!.applicationsAppliedChange > 0) {
                        <p class="flex items-baseline text-sm font-semibold text-green-600 dark:text-green-400">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5 shrink-0 self-center text-green-500 dark:text-green-400">
                                <path
                                    d="M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            <span class="sr-only"> Increased by </span>
                            {{ topLineStats()?.applicationsAppliedChange }}
                        </p>
                        } @else if (topLineStats() && topLineStats()!.applicationsAppliedChange &&
                        topLineStats()!.applicationsAppliedChange < 0) { <p
                            class="flex items-baseline text-sm font-semibold text-red-600 dark:text-red-400">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                class="size-5 shrink-0 self-center text-red-500 dark:text-red-400">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                            </svg>

                            <span class="sr-only"> Decreased by </span>
                            {{ topLineStats()?.applicationsAppliedChange }}
                            </p>
                            }
                    </div>

                </div>


            </div>
        </li>
        <!-- Waiting Applications - END -->


        <!-- Hired, In-Progress -->
        <li class="col-span-1 flex rounded-md card-animate" style="animation-delay: 0s;">
            <div
                class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-gradient-to-br from-[rgb(236,72,153)] to-[rgb(6,182,212)] text-sm font-medium text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-8">
                    <path d="m12.296 3.464 3.02 3.956" />
                    <path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z" />
                    <path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    <path d="m6.18 5.276 3.1 3.899" />
                </svg>
            </div>
            <div
                class="flex flex-1 items-center justify-between truncate rounded-r-md border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-gray-800/50">
                <div class="flex-1 truncate px-4 py-2 text-sm">
                    <p class="text-secondary">Hired, In-Progress</p>
                    <div class="flex flex-row items-baseline gap-x-2">
                        <p class="text-2xl font-semibold text-primary">{{ topLineStats()?.allActiveBriefs }}</p>
                        @if (topLineStats() && topLineStats()!.applicationsHiredOrStartedChange &&
                        topLineStats()!.applicationsHiredOrStartedChange > 0) {
                        <p class="flex items-baseline text-sm font-semibold text-green-600 dark:text-green-400">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5 shrink-0 self-center text-green-500 dark:text-green-400">
                                <path
                                    d="M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            <span class="sr-only"> Increased by </span>
                            {{ topLineStats()?.applicationsHiredOrStartedChange }}
                        </p>
                        } @else if (topLineStats() && topLineStats()!.applicationsHiredOrStartedChange &&
                        topLineStats()!.applicationsHiredOrStartedChange < 0) { <p
                            class="flex items-baseline text-sm font-semibold text-red-600 dark:text-red-400">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                class="size-5 shrink-0 self-center text-red-500 dark:text-red-400">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                            </svg>

                            <span class="sr-only"> Decreased by </span>
                            {{ topLineStats()?.applicationsHiredOrStartedChange }}
                            </p>
                            }
                    </div>

                </div>


            </div>
        </li>
        <!-- Hired, In-Progress - END -->

        <!-- Approved, Not Posted -->
        <li class="col-span-1 flex rounded-md card-animate" style="animation-delay: 0s;">
            <div
                class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-gradient-to-br from-green-500 to-emerald-500 text-sm font-medium text-white">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-8">
                    <path d="M12 13v8" />
                    <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
                    <path d="m8 17 4-4 4 4" />
                </svg>
            </div>
            <div
                class="flex flex-1 items-center justify-between truncate rounded-r-md border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-gray-800/50">
                <div class="flex-1 truncate px-4 py-2 text-sm">
                    <p class="text-secondary">Approved, Not Posted</p>
                    <div class="flex flex-row items-baseline gap-x-2">
                        <p class="text-2xl font-semibold text-primary">{{ topLineStats()?.applicationsReadyToPost }}</p>
                        @if (topLineStats() && topLineStats()!.applicationsReadyToPostChange &&
                        topLineStats()!.applicationsReadyToPostChange > 0) {
                        <p class="flex items-baseline text-sm font-semibold text-green-600 dark:text-green-400">
                            <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="size-5 shrink-0 self-center text-green-500 dark:text-green-400">
                                <path
                                    d="M10 17a.75.75 0 0 1-.75-.75V5.612L5.29 9.77a.75.75 0 0 1-1.08-1.04l5.25-5.5a.75.75 0 0 1 1.08 0l5.25 5.5a.75.75 0 1 1-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0 1 10 17Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                            <span class="sr-only"> Increased by </span>
                            {{ topLineStats()?.applicationsReadyToPostChange }}
                        </p>
                        } @else if (topLineStats() && topLineStats()!.applicationsReadyToPostChange &&
                        topLineStats()!.applicationsReadyToPostChange < 0) { <p
                            class="flex items-baseline text-sm font-semibold text-red-600 dark:text-red-400">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor"
                                class="size-5 shrink-0 self-center text-red-500 dark:text-red-400">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                            </svg>

                            <span class="sr-only"> Decreased by </span>
                            {{ topLineStats()?.applicationsReadyToPostChange }}
                            </p>
                            }
                    </div>

                </div>


            </div>
        </li>
        <!-- Approved, Not Posted - END -->

    </ul>
</div>